import axios from 'axios';
import { BASE_URL, CIS_BASE_URL } from '../Utlils.js';
export const fetchCountryCodes = async (signal) => {
  try {
    const response = await axios.get(
      `${CIS_BASE_URL}/countries?all=true&sort=name&project=asc&fields=name,alpha2Code,alpha3Code,emoji,callingCodes`,
      {
        signal,
      },
    );

    const payload = response.data;
    const countriesData = (
      Array.isArray(payload?.data) ? payload.data : []
    ).map((d) => ({
      label: d?.name || d?.country_name,
      value: d?.iso2 || d?.alpha2Code || d?.country_code,
      icon: d?.emoji,
      countryCode: d?.callingCodes?.[0],
    }));

    return {
      success: true,
      data: countriesData,
      error: null,
    };
  } catch (error) {
    return {
      success: false,
      data: null,
      error: 'Network error. Please check your connection.',
    };
  }
};
export const getCountryCodes = async ({ signal } = {}) => {
  const result = await fetchCountryCodes(signal);

  if (!result.success) throw new Error(result.error);

  return result.data;
};

export const getSupplierRedirect = async (data) => {
  try {
    const { sessionId } = data;
    if (!sessionId) throw new Error('Session ID is required');
    const response = await axios.get(
      `${BASE_URL}/session/${sessionId}/supplier-redirect`,
    );
    const json = response.data;
    if (json?.success) {
      return json ?? {};
    } else {
      const error = json;
      throw new Error(error?.message || 'An error occurred');
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error || 'Network error. Please check your connection.',
    };
  }
};

export const getProviderAvailableSurveys = async ({ id }) => {
  try {
    if (!id) throw new Error('Provider ID is required');
    const response = await axios.get(
      `${BASE_URL}/available-surveys/${encodeURIComponent(id)}`,
    );
    const json = response.data;
    if (json?.success) {
      return json ?? {};
    } else {
      const error = json;
      throw new Error(error?.message || 'An error occurred');
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error || 'Network error. Please check your connection.',
    };
  }
};

export const getProviderSurveyURl = async ({ id, surveyId }) => {
  try {
    if (!id) throw new Error('Provider ID is required');
    if (!surveyId) throw new Error('Survey ID is required');
    const response = await axios.post(`${BASE_URL}/provider-survey-url`, {
      surveyId,
      id: encodeURIComponent(id),
    });
    const json = response.data;
    if (json?.success) {
      return json ?? {};
    } else {
      const error = json;
      throw new Error(error?.message || 'An error occurred');
    }
  } catch (error) {
    return {
      success: false,
      data: null,
      error: error || 'Network error. Please check your connection.',
    };
  }
};
